<template>
  <div class=" is-fullwidth">
    <table class="table is-hoverable is-fullwidth" id="orderstable">
    	<thead>
    		
        <th>Date</th>
   	 		<th>Product</th>
          <th>Qty</th>
          <th>Unit Cost</th>
          <th>Description</th>
          <th width="50">&nbsp;</th>
          
    	</thead>
    	<tbody>
		    <tr v-if="loading === true">
                <td colspan="5" ><div class="notification is-info">Loading orders ...</div></td>
            </tr>
            <tr v-if="loading == false && internal_orders.length == 0">
                <td colspan="5" ><div class="notification is-warning">There are no orders to show</div></td>
            </tr>
            
            <tr v-for="row in internal_orders" v-bind:key="row.id">
         
                <td >{{row.date}}</td>
          <td >{{row.internal_product_name}}</td>
          <td>{{row.quantity}}</td>
          <td>&pound;{{ formatPrice(row.unit_price) }}</td>
          <td>{{ row.description }}</td>
          
          <td>
                <div class="buttons has-addons ">
                  
               </div>
            </td>
          
              
			</tr>
    	</tbody>
    </table>
    
    
    
  </div>
</template>

<script>


import OrderService from '@/services/OrderService.js';
import OrderMixin from "@/mixins/OrderMixin.js";

export default {
  components: {
   	
  },
     mixins: [OrderMixin],
  data() {
    return {
       errors: [],
       internal_orders: [],
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading: true,
      locations: [],
      makeuplocations: [],
      ASP_URL : process.env.VUE_APP_ASP_URL
    }
  },
   methods: {
      async getOrders() {
        this.loading=true
        OrderService.getInternalOrders(this.accessToken)
        .then(
          (internal_orders => {
            this.$set(this, "internal_orders", internal_orders);
            this.loading=false
          }).bind(this)
        );
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2)// .replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }
    
    
  },
  computed : {
      filteredOrders: function () {
       
        let filteredOrders =  this.orders.filter(function(u) {
            if(  u.completed == 1) // u.artwork_new == 0 && u.artwork_repeat == 0 &&
            {
              return 1
            }
          })

          return filteredOrders
       
     }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getOrders();
           this.getMakeupLocations();
        });
  },
 
  mounted() {
    
      
  },
  watch: {
    '$route'() {
      
    }
  }
}


</script>

